const TOKEN_KEY = "dt";

const listeners: ((token: string | null) => void)[] = [];

let _token: string | null = null;

export const setDeviceToken = (token: string): void => {
	// Also store the token in localstorage
	if (token) {
		localStorage.setItem(TOKEN_KEY, token);
		_token = token;
	} else {
		localStorage.removeItem(TOKEN_KEY);
		_token = null;
	}

	listeners.forEach(x => x(token));
};

export const getDeviceToken = (): string | null => {
	if (_token) {
		return _token;
	}
	return localStorage.getItem(TOKEN_KEY);
};

export const subscribeToAccessToken = (callback: (token: string | null) => void): void => {
	listeners.push(callback);
};
